import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'open_with_faire-owf_application_field_value_change-action_unknown';

/**
 * Track when a field in the OWF application form has changed value. Primarily to understand what gets filled and what doesn't (ie; drop-off)
 */
export function trackOpenWithFaireOwfApplicationFieldValueChange(
  FieldName_string: string,
  ApplicationType2: string = 'unknown',
  isSignUp_string3: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { FieldName_string, ApplicationType2, isSignUp_string3 },
  });
}
